import classNames from 'classnames'
import * as React from 'react'

const LogoPro: React.FC = () => (
  <svg
    width="162"
    height="126"
    viewBox="0 0 162 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="120" height="120" rx="24" fill="white" />
    <path
      d="M79.275 59.9625L52.6125 83.7V39.825L43.1625 44.776V92.3625L49.125 97.2L93 57.825L48.45 22.5L39 27.45L79.275 59.9625Z"
      fill="#1BC47D"
    />
    <rect x="82" y="84" width="76" height="38" rx="19" fill="white" />
    <rect
      x="82"
      y="84"
      width="76"
      height="38"
      rx="19"
      stroke="#1BC47D"
      strokeWidth="4"
    />
    <path
      d="M110.25 97.7505L99.75 108.25L94.5 103"
      stroke="#1BC47D"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M117.156 109V97.3636H121.747C122.63 97.3636 123.382 97.5322 124.003 97.8693C124.624 98.2027 125.098 98.6667 125.423 99.2614C125.753 99.8523 125.918 100.534 125.918 101.307C125.918 102.08 125.751 102.761 125.418 103.352C125.084 103.943 124.601 104.403 123.969 104.733C123.34 105.062 122.579 105.227 121.685 105.227H118.759V103.256H121.287C121.761 103.256 122.151 103.174 122.458 103.011C122.768 102.845 122.999 102.616 123.151 102.324C123.306 102.028 123.384 101.689 123.384 101.307C123.384 100.92 123.306 100.583 123.151 100.295C122.999 100.004 122.768 99.7784 122.458 99.6193C122.147 99.4564 121.753 99.375 121.276 99.375H119.617V109H117.156ZM127.676 109V97.3636H132.267C133.145 97.3636 133.895 97.5208 134.517 97.8352C135.142 98.1458 135.617 98.5871 135.943 99.1591C136.272 99.7273 136.437 100.396 136.437 101.165C136.437 101.937 136.27 102.602 135.937 103.159C135.604 103.712 135.121 104.136 134.488 104.432C133.859 104.727 133.098 104.875 132.204 104.875H129.13V102.898H131.806C132.276 102.898 132.666 102.833 132.977 102.705C133.287 102.576 133.519 102.383 133.67 102.125C133.825 101.867 133.903 101.547 133.903 101.165C133.903 100.778 133.825 100.453 133.67 100.188C133.519 99.9223 133.286 99.7216 132.971 99.5852C132.661 99.4451 132.269 99.375 131.795 99.375H130.136V109H127.676ZM133.96 103.705L136.852 109H134.136L131.306 103.705H133.96ZM149.029 103.182C149.029 104.451 148.788 105.53 148.307 106.42C147.83 107.311 147.179 107.991 146.353 108.46C145.531 108.926 144.607 109.159 143.58 109.159C142.546 109.159 141.618 108.924 140.796 108.455C139.974 107.985 139.324 107.305 138.847 106.415C138.37 105.525 138.131 104.447 138.131 103.182C138.131 101.913 138.37 100.833 138.847 99.9432C139.324 99.053 139.974 98.375 140.796 97.9091C141.618 97.4394 142.546 97.2045 143.58 97.2045C144.607 97.2045 145.531 97.4394 146.353 97.9091C147.179 98.375 147.83 99.053 148.307 99.9432C148.788 100.833 149.029 101.913 149.029 103.182ZM146.535 103.182C146.535 102.36 146.411 101.667 146.165 101.102C145.923 100.538 145.58 100.11 145.137 99.8182C144.694 99.5265 144.175 99.3807 143.58 99.3807C142.985 99.3807 142.466 99.5265 142.023 99.8182C141.58 100.11 141.235 100.538 140.989 101.102C140.747 101.667 140.626 102.36 140.626 103.182C140.626 104.004 140.747 104.697 140.989 105.261C141.235 105.826 141.58 106.254 142.023 106.545C142.466 106.837 142.985 106.983 143.58 106.983C144.175 106.983 144.694 106.837 145.137 106.545C145.58 106.254 145.923 105.826 146.165 105.261C146.411 104.697 146.535 104.004 146.535 103.182Z"
      fill="#1BC47D"
    />
  </svg>
)

export type Props = {
  onClick: () => void
  className?: string
}
export const WelcomeToTheProClub: React.FC<Props> = ({
  onClick,
  className,
}) => (
  <div className={classNames('flex flex-col gap-4', className)}>
    <div className="bg-green aspect-[16/9] rounded-[10px] flex flex-col items-center justify-center">
      <div className="pl-8">
        <LogoPro />
      </div>
    </div>

    <p className="txt-[24_32_700]">Welcome to the PRO club!</p>

    <p className="txt-[14_24_400]">
      You have now unlocked a bunch of exciting features.
      <br />
      Thank you for your support! You are awesome 🙂
    </p>

    <button
      onClick={onClick}
      className={classNames(
        'w-fit ml-auto',
        'txt-[18_24_600] text-white bg-green px-4 py-2 rounded-[8px]',
        'flex flex-row items-center gap-2',
        'hover:scale-105',
        'transition-transform duration-300 hover:duration-150 hover:ease-in ease-out'
      )}
    >
      Let's go
    </button>
  </div>
)
